export type LogLevel = 'error' | 'warning' | 'info' | 'system';

// Filled at ~14% of the level colour (the `24` alpha suffix in the artboards).
const LEVELS: Record<LogLevel, string> = {
  error: 'text-state-err bg-state-err/[0.14]',
  warning: 'text-state-warn bg-state-warn/[0.14]',
  info: 'text-action-soft bg-action-soft/[0.14]',
  system: 'text-state-ok-soft bg-state-ok-soft/[0.14]',
};

const LogLevelBadge = ({ level, fixedWidth = false }: {
  level: LogLevel,
  /** Fixed 52px column, so desktop log lines stay in register. */
  fixedWidth?: boolean,
}) => (
  <span
    className={[
      'flex-none font-courrier font-bold uppercase rounded-[3px] text-center',
      'text-[9.5px] leading-none tracking-[0.06em] py-[3px]',
      fixedWidth ? 'w-[52px]' : 'px-1.5',
      LEVELS[level],
    ].join(' ')}
  >
    {level}
  </span>
)

export default LogLevelBadge
